import { Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import DateDespreClientRows from './DateDespreClientRows';
import OpenEditFactura from './Dialogs/OpenEditFactura';


export default class DateDespreClient extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            clientiH: {},
            client: {},
            facturi: [],
            openDeleteFactura: false,
            facturaSelectata: {},
            openInsertFactura: false,
            openEditFactura: false,
            alertView:false
        }
    }

    ws = new Ws()
    u = new Utils()
    m = new Masks()
    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getData()
    }


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }


    getData = async () => {


        let clientiRows = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where id = @p1 and isnull(sters,0) != 1', {
            p1: this.props.match.params.idClient
        })


        if (clientiRows.Succes) {
            let _getClienti = this.ws.customSelect('select * from fin_import_raport_lunar_clienti_head where id = @p1 ', {
                p1: clientiRows.Content[0].id_head
            })

            let _getFacturi = this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where localitate = @p1 and isnull(sters,0) != 1', {
                p1: clientiRows.Content[0].localitate
            })


            let [getClienti, getFacturi] = await Promise.all([_getClienti, _getFacturi])


            if (getClienti.Succes && getFacturi.Succes) {

                console.log('getClienti :>> ', getClienti);

                console.log('getFacturi :>> ', getFacturi);

                let facturi = [...getFacturi.Content]

                console.log('facturi :>> ', facturi);

                let facturiFilter = facturi.filter(c => c.document && (c.document.length > 0))


                // console.log('facturiFilter :>> ', facturiFilter);

       
                let client = {
                    nume: clientiRows.Content[0].localitate,
                    sold_total: 0,
                    id:clientiRows.Content[0].id_head

                }



                for (let i = 0, n = facturiFilter.length; i < n; i++) {

                    facturiFilter[i]['zile_depasite'] =  this.m.jsDatesDifferenceInDays( new Date(this.u.ParseDataFromSql(facturiFilter[i].termen)), new Date() ) <= 0 ? 0 : this.m.jsDatesDifferenceInDays( new Date(this.u.ParseDataFromSql(facturiFilter[i].termen)), new Date() )

                    client['sold_total'] += facturiFilter[i].rest || 0
                }

                client.sold_total = this.u.toFixedIfNecessary(client.sold_total, 2)

                console.log('client :>> ', client);

                console.log('facturiFilter :>> ', facturiFilter);

                this.setState({
                    clientiH: getClienti.Content[0],
                    client: client,
                    facturi: facturiFilter,
                    facturaSelectata: { localitate: client.nume }
                })



            }
        }




    }


    inapoi = () => {
        this.props.history.goBack()
    }


    openDeleteFactura = (f) => {

        console.log('f :>> ', f);

        this.setState({
            openDeleteFactura: true,
            facturaSelectata: f
        })
    }


    deleteFactura = async () => {


        let delFactura = await this.ws.update('fin_import_raport_lunar_clienti_rows', { sters: 1 }, { id: this.state.facturaSelectata.id })

        if (delFactura.Succes) {

            this.setState({ openDeleteFactura: false }, () => {

                this.getData()
            })
        }

    }


    openEditFactura = (f) => {


        let factura = f

        factura['data_emitere'] = this.u.ParseDataFromSql( factura['data_emitere'])
        factura['data_ultimei_incasari'] = this.u.ParseDataFromSql(factura['data_ultimei_incasari'])
        this.setState({
            openEditFactura: true,
            facturaSelectata: f
        })

    }

    openInsertFactura = () => {

        console.log('client :>> ', this.state.client);
        let facturaToInsert = {
            localitate: this.state.client.nume,
            document: '',
            valoare: 0,
            data_emitere: this.u.defaultData(),
            data_ultimei_incasari: this.u.defaultData(),
            termen:this.u.defaultData(), 
            rest:0,
            id_head:this.state.client.id
        }

        this.setState({
            openInsertFactura: true,
            facturaSelectata: facturaToInsert
        })

    }

    salveazaFactura = async () => {

        let facturaToSave = {
            document: this.state.facturaSelectata.document,
            valoare: this.state.facturaSelectata.valoare,
            data_emitere: this.state.facturaSelectata.data_emitere,
            data_ultimei_incasari: this.state.facturaSelectata.data_ultimei_incasari,
            rest:this.state.facturaSelectata.rest,
            termen:this.state.facturaSelectata.termen,
        }

        let saveFactura = await this.ws.update('fin_import_raport_lunar_clienti_rows', facturaToSave, { id: this.state.facturaSelectata.id })

        if (saveFactura.Succes) {
            this.setState({ openEditFactura: false }, () => {
                this.getData()
            })
        }

    }


    insertFactura = async () => {

        console.log('this.staet.facturaSelectata :>> ', this.state.facturaSelectata);

        let factura = this.state.facturaSelectata
        factura['rest'] = factura.valoare

        let saveFactura = await this.ws.insert('fin_import_raport_lunar_clienti_rows', this.state.facturaSelectata)

        if (saveFactura.Succes) {
            this.setState({ openInsertFactura: false }, () => {
                this.getData()
            })
        }

    }



    changeFactura = (ev) => {

        let v = ev.target.value;
        let n = ev.target.name;

        let factura = { ...this.state.facturaSelectata }


        factura[n] = v;

        this.setState({ facturaSelectata: factura })
    }


    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <AlertNew
                    open={this.state.openDeleteFactura}
                    dialogClose={() => { this.setState({ openDeleteFactura: false }) }}
                    title={'Sunteti sigur ca vreti sa stergeti factura selectata ?'}
                    mesaj={'Odata stearsa, factura nu va mai putea fi recuperata !'}
                    yesFunction={this.deleteFactura}
                />




                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.clienti} in {this.state.clientiH.an} </h1>
                    </Grid>


                    <DateDespreClientRows
                        client={this.state.client}
                        facturiRows={this.state.facturi}
                        addFacturaNoua={this.openInsertFactura}
                        editFactura={this.openEditFactura}
                        deleteFactura={this.openDeleteFactura}
                        inapoi={this.inapoi}
                    />

                    <OpenEditFactura
                        open={this.state.openEditFactura}
                        dialogClose={() => { this.setState({ openEditFactura: false }) }}
                        factura={this.state.facturaSelectata}
                        changeFactura={this.changeFactura}
                        salveazaFactura={this.salveazaFactura}
                    />

                    <OpenEditFactura
                        open={this.state.openInsertFactura}
                        dialogClose={() => { this.setState({ openInsertFactura: false }) }}
                        factura={this.state.facturaSelectata}
                        changeFactura={this.changeFactura}
                        salveazaFactura={this.insertFactura}
                    />




                    {this.state.facturi.length === 0 &&
                        <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                        {this.dictionary.financiar.dateDespreClientMesaj} {this.state.clientiH.an} {this.dictionary.financiar.dateDespreClientMesaj2} </span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} className='material-icons'>clear</i>
                                </div>

                            </div>


                        </Grid>

                    }




                </Grid>

            </div >
        );
    }
}